'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';
import {bp} from '../../../_scripts/_helper';
import ScrollMagic from 'scrollmagic';
import '../../../_scripts/slick';
// import 'scrollmagic-debug';

// export default class Notification {
//   constructor() {
//     let $notifyBtn =  $('.js-notify-btn'),
//         $notification = $('.notification'),
//         $backtotop = $('.back-to-top'),
//         $numbers = $('.numbers', $notifyBtn),
//         notificationVisible = true; // By default set the notification visible

//     if ($notification.length < 1) {
//       $numbers.addClass('viewed');
//       $notifyBtn.prop('disabled', true);
//     }

//     // Mobile notification
//     enquire.register("screen and (max-width:"+bp.minDesktop+"px)", {
//       match : function() {

//         // Init ScrollMagic
//         var controller = new ScrollMagic.Controller();

//         // build a scene
//         var scene1 = new ScrollMagic.Scene({
//           triggerElement: '#mainContent',
//           duration: '70%'
//         })
//         .setClassToggle('.notification-btn', 'no-back-btn') // add class to project01
//         // .addIndicators({
//         //   name: 'fade scene',
//         //   colorTrigger: 'black',
//         //   indent: 200,
//         //   colorStart: '#75C695'
//         // }) // this requires a plugin
//         .addTo(controller);


//         $notifyBtn.on('click.mblNotification', function(e) {
//           e.preventDefault();
//           let $this = $(this);
//           $notification.toggleClass('mbl-hidden');
//           $this.toggleClass('active');
//           if($this.hasClass('active') && !$numbers.hasClass('viewed')) {
//             $numbers.addClass('viewed');
//           }
//           $backtotop.toggleClass('notify-open');
//         });
//       },
//       unmatch : function() {
//         $notifyBtn.off('click.mblNotification');
//       }
//     });

//     // Desktop notification
//     enquire.register("screen and (min-width:"+bp.minDesktop+"px)", {
//       match : function() {
//         $notifyBtn.on('click.dskNotification', function(e) {
//           e.preventDefault();
//           let $this = $(this);
//           $notification.toggleClass('active');
//           $this.toggleClass('active');
//           if($notification.hasClass('active')) {
//             $notification.slideDown(250);
//           } else {
//             $notification.slideUp(250);
//           }
//           if(!$numbers.hasClass('viewed')) {
//             $numbers.addClass('viewed');
//           }
//         });
//       },
//       unmatch : function() {
//         $notifyBtn.off('click.dskNotification');
//         $notification.css('display',''); // reset display property
//       }
//     });


//     // Use localStorage to check whether the notification is new or old
//     if(typeof(Storage) !== "undefined") {
//       let pubDate = $('.notification').attr('data-pubdate'), // get the notification published date
//         notificationPublished = new Date(pubDate),
//         notificationPublishedMs = notificationPublished.getTime(); // notification pusblished time in milliseconds

//       if(localStorage.getItem("notification") === null) { // This will be true if the user is new to the site or the user cleared cache
//         localStorage.notification = notificationPublishedMs; // set local storage value
//       } else { // the below code will run if repeated user
//         // compage existing localStorage value with notification published time
//         if (localStorage.notification != notificationPublishedMs) { // if the notification published time is different from localStorage
//           notificationVisible = true;
//           localStorage.notification = notificationPublishedMs; // override the localStorage value
//         } else {
//           notificationVisible = false;
//         }
//       }
//     }

//     // show hide notification based on localStorage value
//     if(!notificationVisible) {
//       if(!$numbers.hasClass('viewed')) {
//         $numbers.addClass('viewed');
//       }
//     } else {
//       enquire.register("screen and (min-width:"+bp.minDesktop+"px)", {
//         match: function() {
//           // if the notification is new, then open it on desktop by default
//           if($('.home').length > 0) {
//             $notification.addClass('is-visible active');
//           }
//         }
//       });
//     }

//   }
// }

// Notification 

$('#announcement_notify').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: '<a href="#" class="announcement-next slick-next"><i class="icon-arrow_small_next"></i><span class="visuallyhidden">button to view the next announcement</span></a>',
  prevArrow: '<a href="#" class="announcement-prev slick-prev"><i class="icon-arrow_small_prev"></i><span class="visuallyhidden">button to view the previous announcement</span></a>',
  dots: !0,
  dotsClass: 'custom_paging',
  customPaging: function (slider, i) {
      return i + 1 + '/' + slider.slideCount;
  },
  responsive: [
      {
          breakpoint: 1023,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      }
  ]
});

$('.close_announcement').on('click', function () {
  $('.header_announcement').slideUp("slow");
});

function triggerNotificationViewed(){
    if(!$(".notify-menu .numbers").hasClass('viewed')){
        $(".notify-menu .numbers").addClass('viewed')
    }
    if(!$(".notification-btn .numbers").hasClass('viewed')){
        $(".notification-btn .numbers").addClass('viewed')
    }
}

$('.notify-menu').on('click', function () {
    $('.header_announcement').slideToggle("slow");
    triggerNotificationViewed()
  });

  $('.notification-section .notification-btn').on('click',function(){
    $('.header_announcement').slideToggle("slow");
    triggerNotificationViewed()
  })